<!--
  - Copyright (c) 2022. Haodong JU
  -->

<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    app
    class="elevation-4"
    color="#1a1a1a"
    dark
    permanent
    stateless
    touchless
    v-bind="$attrs"
    width="260"
  >
    <v-card
      class="pa-6 px-4 d-flex align-center"
      color="#000000"
      dark
      tile
    >
      <v-avatar
        class="mr-4"
        color="primary"
        size="42"
      >
        <span class="white--text text-h6 font-weight-bolds">{{ restaurantName.substring(0, 2) }}</span>
      </v-avatar>
      <div class="flex-grow-1">
        <div class="text-subtitle-1 text-capitalize">
          {{ restaurantName }}
        </div>
        <div class="grey--text text--lighten-1 text-caption">
          {{ Version }} edge
        </div>
      </div>
    </v-card>

    <v-list
      class="pb-16"
      expand
      nav
    >
      <v-list-item-group>
        <template v-for="(firstItem,i) in computedItems">
          <template v-if="firstItem.children">
            <v-list-group
              :key="'firstItem'+i"
              :prepend-icon="firstItem.icon"
            >
              <template #activator>
                <v-list-item-title
                  class="text-h4"
                  @click="goto(firstItem.groupTo)"
                >
                  {{ firstItem.title }}
                </v-list-item-title>
              </template>

              <template v-for="(secondItem,j) in firstItem.children">
                <template v-if="secondItem.children">
                  <v-list-group
                    :key="'second'+j"
                    no-action
                    sub-group
                  >
                    <template #activator>
                      <v-list-item

                        class="text-h3"
                        dense
                      >
                        <v-list-item-icon class="my-2">
                          <v-icon small>
                            mdi-checkbox-blank-circle
                          </v-icon>
                        </v-list-item-icon>
                        <v-list-item-title class="text-h4">
                          {{ secondItem.title }}
                        </v-list-item-title>
                      </v-list-item>
                    </template>

                    <v-list-item
                      v-for="(thirdItem,k) in secondItem.children"
                      :key="'third'+k"
                      :to="secondItem.group+'/' +thirdItem.to"
                      dense
                    >
                      <v-list-item-icon class="my-2">
                        <v-icon small>
                          mdi-circle-medium
                        </v-icon>
                      </v-list-item-icon>
                      <v-list-item-title class="text-h4">
                        {{ thirdItem.title }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list-group>
                </template>

                <template v-else>
                  <v-list-item
                    :key="'second'+j"
                    :to="firstItem.group+'/' +secondItem.to"
                    dense
                  >
                    <v-list-item-icon class="my-2">
                      <v-icon small>
                        mdi-circle-medium
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-title class="text-h4">
                      {{ secondItem.title }}
                    </v-list-item-title>
                  </v-list-item>
                </template>
              </template>
            </v-list-group>
          </template>
          <template v-else-if="firstItem.header">
            <v-subheader
              :key="firstItem.header+i"
              class="pl-2"
            >
              {{ firstItem.header }}
            </v-subheader>
          </template>
          <template v-else-if="firstItem.divider">
            <div
              :key="'fistMenu'+i+'D'"
              style="width: calc(100% + 48px)"
            >
              <v-divider
                class="my-2 mx-n4"
                style="width: calc(100%)"
              />
            </div>
          </template>
          <template v-else>
            <v-list-item
              :key="'firstMenu'+i"
              :to="firstItem.to"
              class="py-1"
              dense
            >
              <v-list-item-icon class="my-2">
                <v-icon>{{ firstItem.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="text-h4">
                {{ firstItem.title }}
              </v-list-item-title>
            </v-list-item>
          </template>
        </template>
      </v-list-item-group>
    </v-list>
    <template #append>
      <div class="pa-4 d-flex">
        <div>
          <v-img
            contain
            src="@/assets/logoWhiteH.png"
            width="84px"
          />
        </div>

        <v-spacer/>
        <div>
          <v-menu
            v-model="showLang"
            bottom
            offset-x
          >
            <template #activator="{attrs, on}">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>
                  mdi-web
                </v-icon>
              </v-btn>
            </template>

            <v-list
              :tile="false"
              nav
            >
              <v-list-item
                v-for="(n, i) in transLangs"
                :key="i"
                @click="changeLanguage(n)"
              >
                <v-list-item-title
                  v-text="$t(n)"
                />
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </div>
    </template>

    <v-dialog
      v-model="showLogout"
      max-width="40vw"
    >
      <v-card height="20vh">
        <div class="d-flex justify-space-between flex-nowrap align-center">
          <div style="width: 125px">
            <v-img
              src="@/assets/logonew.png"
            />
          </div>

          <div>
            <v-card-title class="text-h3 py-6">
              {{ $t('are_you_sure') }} {{ ' ' }}{{ $t('Do you want to logout?') }}
            </v-card-title>

            <v-card-actions
              class="fill-height"
              style="vertical-align: bottom"
            >
              <v-spacer/>
              <v-btn
                class="red white--text"
                to="/pages/login"
              >
                {{ $t('OK') }}
              </v-btn>
              <v-btn
                class="green white--text"
                @click="showLogout= false"
              >
                {{ $t('Cancel') }}
              </v-btn>
            </v-card-actions>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </v-navigation-drawer>
</template>

<script>
  // Utilities
  import { mapMutations, mapState } from 'vuex'
  import { version } from '../../../../../package.json'
  import { changeLanguage, isRestaurant } from '@/GlobalSettings'
  import { getNiceRestaurantInfo } from '@/common/Utlis/api'
  import { bubbleTeaMenu, restaurantMenu } from '@/views/dashboard/components/core/navigation'
  import IKUtils from 'innerken-js-utils'
  import Servant from '@/model/tableAndPerson/Servant'
  import { loadTransLangs } from '../../../../i18n'

  export default {

    name: 'DashboardCoreDrawer',

    components: {},
    props: {
      expandOnHover: {
        type: Boolean,
        default: false,
      },
    },
    data: () => ({
      restaurantName: '',
      showLogout: false,
      showLang: false,
      menuRouter: isRestaurant() ? restaurantMenu : bubbleTeaMenu,
      Version: version,
      toggleBriefView: false,

      currentAuth: null,
      profile: [
        { title: 'logout' },
      ],
    }),

    computed: {
      ...mapState(['barColor', 'barImage', 'accessLevel', 'drawer']),
      drawer: {
        get () {
          return this.$store.state.drawer
        },
        set (val) {
          console.log(val)
          this.$store.commit('SET_DRAWER', val)
        },
      },
      computedItems () {
        return this.menuRouter.filter(it => {
          return !it.hide && (!this.currentAuth || this.currentAuth.includes(it.key) || it.mustshow)
        }).map(this.mapItem)
      },
      transLangs () {
        return loadTransLangs()
      },
    },

    watch: {
      '$vuetify.breakpoint.smAndDown' (val) {
        this.$emit('update:expandOnHover', !val)
      },
    },
    async mounted () {
      this.restaurantName = (await getNiceRestaurantInfo()).name
      const pw = IKUtils.getQueryString('pw')
      const servantName = (await Servant.getList(true)).find(it => it.password === pw)
      try {
        this.currentAuth = JSON.parse(servantName.rawAuth).powerBackend.map(it => it.authName)
      } catch (e) {
        this.currentAuth = null
      }
    },
    methods: {
      changeLanguage,
      loadTransLangs,
      ...mapMutations({
        setDrawer: 'SET_DRAWER',
      }),
      goto (route) {
        if (route) {
          this.$router.push(route)
        }
      },
      mapItem (item) {
        return {
          ...item,
          children: item.children ? item.children.map(this.mapItem) : undefined,
          title: this.$t(item.title),
        }
      },
    },

  }
</script>

<style lang="sass">
@import '~vuetify/src/styles/tools/_rtl.sass'

#core-navigation-drawer
  &.v-navigation-drawer--mini-variant
    .v-list-item
      justify-content: flex-start !important

    .v-list-group--sub-group
      display: block !important

  .v-list-group__header.v-list-item--active:before
    opacity: .24

  .v-list-item
    &__icon--text,
    &__icon:first-child
      justify-content: center
      text-align: center
      width: 20px

      +ltr()
        margin-right: 24px
        margin-left: 12px !important

      +rtl()
        margin-left: 24px
        margin-right: 12px !important

  .v-list--dense
    .v-list-item
      &__icon--text,
      &__icon:first-child
        margin-top: 10px

  .v-list-group--sub-group
    .v-list-item
      +ltr()
        padding-left: 8px

      +rtl()
        padding-right: 8px

    .v-list-group__header
      +ltr()
        padding-right: 0

      +rtl()
        padding-right: 0

      .v-list-item__icon--text
        margin-top: 19px
        order: 0

      .v-list-group__header__prepend-icon
        order: 2

        +ltr()
          margin-right: 8px

        +rtl()
          margin-left: 8px
</style>
